import { Link } from "@tanstack/react-router";
import { Calculator, ArrowRight } from "lucide-react";
import { CALCULATOR_PATH } from "@/lib/calculator-flag";

/**
 * Promotional strip above the hero for the instant roof cost calculator.
 * Full-bleed light band that separates the white navigation from the navy hero.
 */
export function InstantEstimateStrip() {
  return (
    <section aria-label="Instant roof cost estimate" className="relative block w-full">
      <Link
        to={CALCULATOR_PATH}
        className="group relative block w-full overflow-hidden"
      >
        <div className="absolute inset-0 border-y border-border bg-surface" />
        <svg
          aria-hidden="true"
          className="absolute inset-0 h-full w-full opacity-[0.045]"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="strip-chevrons" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 20 L20 0 L40 20" stroke="var(--primary)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#strip-chevrons)" />
        </svg>

        <div className="relative mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-4">
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:gap-12">
            {/* content group */}
            <div className="flex flex-col items-center gap-4 text-center md:flex-row md:gap-6 md:text-left">
               <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent/10 ring-1 ring-accent/20">
                <Calculator className="h-6 w-6 text-accent" aria-hidden="true" />
              </div>
              <div className="space-y-1">
                 <h2 className="text-xl font-extrabold tracking-tight text-primary lg:text-2xl">
                  Get an Instant Roofing Estimate
                </h2>
                 <p className="text-sm font-medium text-muted-foreground lg:text-base">
                  Answer a few questions, get your Phoenix price range in about a minute.
                </p>
              </div>
            </div>

            {/* CTA button */}
            <div className="shrink-0">
              <div className="flex items-center gap-2 rounded-lg bg-accent px-8 py-3.5 text-sm font-bold uppercase tracking-wider text-white shadow-lg transition-all duration-200 group-hover:bg-[#e67510] group-hover:shadow-orange-900/20">
                <span>Start Estimate</span>
                <ArrowRight
                  className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </section>
  );
}
